// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18cfbd63","727":"488664f4"}[chunkId] + ".chunk.js";
};